/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import {
	PageShell,
	SectionDivider,
	SectionWrapper,
} from "./Achievements.page-primitives";
import DotGrid from "@/components/customCopmonent/DotGrid";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useScroll, useTransform, motion } from "motion/react";
import VerticalTimeline, {
	type Milestone,
} from "@/components/customCopmonent/Timeline";
import { PageHeaderHero, PAGE_HERO_CLASS } from "@/components/customCopmonent/Text/PageHeaderHero";
import Seo from "@/components/Seo";

const bgimage = "/images/header/OurjourneyMilestone-1.JPG";

const Achievements = () => {
	const { t } = useTranslation();

	const meta = t("aboutPages.achievements.meta", {
		returnObjects: true,
	}) as string[];

	const milestones = t("aboutPages.achievements.milestones", {
		returnObjects: true,
	}) as Milestone[];

	const containerRef = useRef(null);

	const { scrollYProgress } = useScroll({
		target: containerRef,
		offset: ["start end", "end start"],
	});

	const lineHeight = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

	return (
		<PageShell>
			<Seo
				titleKey="aboutPages.achievements.seo.title"
				descriptionKey="aboutPages.achievements.seo.description"
				path="/achievements"
			/>
			<Navigation />{" "}
			<SectionWrapper className={PAGE_HERO_CLASS}>
				<div className="absolute inset-0 ">
					{" "}
					<div
						className="absolute bottom-3 inset-0 opacity-35 scale-105"
						style={{
							backgroundImage: `url(${bgimage})`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					/>
					<DotGrid
						dotSize={4}
						gap={15}
						baseColor="#3b0092"
						activeColor="#f09a38"
						proximity={100}
						shockRadius={200}
						shockStrength={3}
						resistance={750}
						returnDuration={1.5}
					/>
				</div>
				<PageHeaderHero
					// align="center"
					title={t("aboutPages.achievements.title")}
					description={t("aboutPages.achievements.tagline")}
					meta={meta}
				/>
			</SectionWrapper>
			<SectionDivider />
			<section
				ref={containerRef}
				className="relative py-10 md:py-20">
				{/* Animated Vertical Line — belongs to the desktop "snake" layout; the
				    mobile timeline draws its own rail, so this would otherwise cut
				    straight through the stacked cards. */}
				<div className="absolute left-1/2 top-0 hidden h-full w-[3px] -translate-x-1/2 bg-slate-200 md:block">
					<motion.div
						style={{ height: lineHeight }}
						className="w-full bg-gradient-to-b from-[#2d2f92] via-[#f9a93a] to-transparent"
					/>
				</div>

				<VerticalTimeline milestones={milestones} />
			</section>
			<FooterSection />
		</PageShell>
	);
};

export default Achievements;
